/** Shared game interface colours, independent of player and game-piece colours. */
export const interfaceColors = {
  background: "#07080d",
  panel: "#0f172a",
  border: "#334155",
  muted: "#94a3b8",
  text: "#ffffff",
  secondaryText: "#cbd5e1",
  action: "#9333ea",
  actionBorder: "#c084fc",
  actionSurface: "#2b1742",
  atmosphere: "#28143e",
  focus: "#67e8f9"
} as const;
